import React from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";

import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import SvgI24Menu from "assets/icons/I24Menu";

import { Button, Typography } from "@material-ui/core";
import TrimmedText from "components/TrimmedText";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  MenuContent,
  MenuContentWrapper,
  Menu,
} from "./styles";

type Props = {
  id: number;
  title: string;
  day: number;
  duration?: string;
  image: string;
  onRemove: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  isDragging?: boolean;
};

const SequenceDetailsCard: React.FC<Props> = ({
  title,
  day,
  image,
  onRemove,
  dragHandleProps,
  isDragging,
}) => {
  return (
    <Container isDragging={isDragging}>
      <ImageContainer image={image} />
      <DetailsContainer>
        <TextContainer>
          <TitleWrapper>
            <TrimmedText lines={1} text={title}>
              <Typography variant="h3" color="textPrimary">
                {title}
              </Typography>
            </TrimmedText>
          </TitleWrapper>
          <Typography variant="subtitle1" color="secondary">
            Day: {day}
          </Typography>
        </TextContainer>
        <BottomControlsContainer>
          <ControlWrapper>
            <Button
              startIcon={<RemoveCircleOutlineIcon />}
              variant="text"
              color="secondary"
              onClick={onRemove}
            >
              Remove
            </Button>
          </ControlWrapper>
        </BottomControlsContainer>
      </DetailsContainer>

      {dragHandleProps && (
        <MenuContent isDraggable={!!dragHandleProps}>
          <MenuContentWrapper>
            <Menu {...dragHandleProps}>
              <SvgI24Menu />
            </Menu>
          </MenuContentWrapper>
        </MenuContent>
      )}
    </Container>
  );
};

export default SequenceDetailsCard;
